import Link from '~/src/atoms/Link';
import SKUDeck from '~/src/organisms/SKUDeck';
import useSelectedPack from './useSelectedPack';
import URI from 'urijs';
import { PHARMA_EC_ID } from '~/src/context/Common/commonHeader';
const DeckHeadingLink = ({
  visibility,
  showBrand,
  hideBrandNameForParticularBrand,
  showProductName,
  listType,
  screenInPageContext,
  screenInPagePosition,
  screenItemName,
  screenItemPosition,
  ...rest
}) => {
  const { absoluteUrl } = useSelectedPack();
  const isHideBrand = visibility?.supply_chain_ecs?.includes(PHARMA_EC_ID) || hideBrandNameForParticularBrand;
  const convertedAbsoluteUrl = URI(absoluteUrl);

  if (listType && listType !== 'ms') {
    convertedAbsoluteUrl.addQuery({ nc: listType });
  }

  if (listType === 'ms') {
    convertedAbsoluteUrl.addQuery({ nc: 'beforeyoucheckout' });
  }

  if (screenInPageContext) {
    convertedAbsoluteUrl.addQuery({ nc: screenInPageContext });
  }

  if (screenInPagePosition) {
    convertedAbsoluteUrl.addQuery({ t_pos_sec: screenInPagePosition });
  }

  if (screenItemPosition) {
    convertedAbsoluteUrl.addQuery({ t_pos_item: screenItemPosition });
  }

  if (screenItemName) {
    convertedAbsoluteUrl.addQuery({ t_s: screenItemName });
  }

  return (
    <Link
      {...rest}
      href={`${convertedAbsoluteUrl}`}
      target="_blank"
      rel="noopener noreferrer"
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="h-full">
      {isHideBrand ? null : <SKUDeck.BrandName showBrand={showBrand} />}
      <SKUDeck.ProductName showProductName={showProductName} />
    </Link>
  );
};

export default DeckHeadingLink;
